import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { apiGetListProffitSearchFolder } from '../../../../actions/ProffitSearchSlideActions';
import { propShape } from '../../../../helpers/custom-prop-types';
import { compose } from '../../../../helpers/recompose';
import { useMyPageFolderRename } from '../../../../helpers/use/proffit_search/mypage/useMyPageFolderRename';
import { useUnmountRef } from '../../../../helpers/use/useHook';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import ProffitSearchFolderHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchFolderHoc';
import ProffitSearchInformationHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchInformationHoc';
import ProffitSearchRegistrationDeviceHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchRegistrationDeviceHoc';
import ProffitSearchTutorialHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchTutorialHoc';
import SlideSearchListOneTemplate from '../../List/SlideSearchListOneTemplate';
import FolderName from './Parts/MyFolder/FolderList/FolderName';
const MyFolderOneInner = (props) => {
    const { folder, proffitSearch } = props;
    const { id, name: folderName } = folder;
    const unmountRef = useUnmountRef();
    const pans = useMemo(() => [
        {
            link: '/mypage',
            text: 'マイページ',
        },
        {
            link: '/proffit_search',
            text: 'PROFFIT SEARCH',
        },
        {
            link: '/proffit_search/folder',
            text: 'Myフォルダ',
        },
        {
            text: folderName,
        },
    ], [folderName]);
    const wrapAction = useCallback((params, meta) => apiGetListProffitSearchFolder(id, params, meta), [id]);
    const { initialValues, inputRef, isShowForm, name, onSubmit, showForm } = useMyPageFolderRename.useMyPageFolderRenameForm(unmountRef, folder);
    return (_jsx(SlideSearchListOneTemplate, { action: wrapAction, keywordPlaceholder: `${folderName} 内の検索`, pans: pans, proffitSearch: proffitSearch, renderHeader: () => (_jsx("div", Object.assign({ className: 'proffit_search_folder_update' }, { children: _jsx(FolderName, { fieldClassName: 'proffit_search_folder_update_input', formClassName: 'proffit_search_folder_update_form', id: id, initialValues: initialValues, inputRef: inputRef, isShowForm: isShowForm, name: name, onSubmit: onSubmit, showForm: showForm, textRowClassName: 'proffit_search_folder_update_text' }) }))), title: name }));
};
MyFolderOneInner.propTypes = {
    folder: propShape().isRequired,
    proffitSearch: propShape().isRequired,
};
const MyFolderOne = compose(AuthenticationHoc({ isCanUseProffitSearch: true }), ProffitSearchRegistrationDeviceHoc(), ProffitSearchTutorialHoc(), ProffitSearchInformationHoc(), ProffitSearchFolderHoc())(MyFolderOneInner);
export default MyFolderOne;
